<h2 mat-dialog-title>{{ 'COMPONENT_TITLE.API_KEY_CREATE' | translate }}</h2>
<mat-dialog-content>
    <form [formGroup]="form" class="row gy-2 gx-3">
        <div class="col-md-12 p-15" #messages *ngIf="errorMessages != []">
            <p-messages [(value)]="errorMessages" [closable]="false" [ngClass]="'warn-text'"></p-messages>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100" color="primary">
                <mat-label>{{ 'ITEM.API_KEY_NAME' | translate }} </mat-label>
                <input type="text" matInput fullWidth formControlName="name" />
                <mat-error *formErrorMessages="form.get('name') ; let error">
                    {{ error }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100" color="primary">
                <mat-label>{{ 'ITEM.RESTRICTION' | translate }}</mat-label>
                <mat-select formControlName="restriction">
                    <mat-option *ngFor="let option of API_KEY_RESTRICTIONS" [value]="option">
                        {{ ('ITEM.RESTRICTION_ITEM.' + option) | translate }}
                    </mat-option>
                </mat-select>
                <mat-error *formErrorMessages="form.get('restriction') ; let error">
                    {{ error }}
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-md-12">

            <!-- HTTP / IP のときだけ表示 -->
            <div class="row" *ngIf="isRestricted()">

                <div class="col-md-12 mb-3 p-3">
                    <div formArrayName="restrictions">
                        <div *ngFor="let ctrl of restrictions.controls; let i = index"
                            class="d-flex align-items-center mb-2">
                            <mat-form-field appearance="outline" class="flex-grow-1 w-100">
                                <input matInput [formControlName]="i"
                                    [placeholder]="'ITEM.RESTRICTION_INPUT' | translate">
                                <mat-error *formErrorMessages="restrictions.get(i +'') ; let error">
                                    {{ error }}
                                </mat-error>
                            </mat-form-field>
                            <button mat-icon-button color="warn" (click)="removeRestrictionText(i)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                    <button mat-button color="primary" (click)="addRestrictionText()">
                        <mat-icon>add</mat-icon> {{ 'BUTTON.ADD_RESTRICTION' | translate }}
                    </button>
                </div>

                <div *ngIf="form.get('restriction')?.value == 'HTTP' " class="col-md-12 mb-3 p-3">
                    <h4 class="mb-2">{{ 'MESSAGES.RESTRICTION_HTTP_TITLE' | translate }}</h4>
                    <p [innerHTML]="'MESSAGES.RESTRICTION_HTTP_DESC' | translate"></p>
                    <ul>
                        <li>https://www.example.com/path</li>
                        <li>https://sub.example.com/*</li>
                        <li>https://*.example.com/*</li>
                        <li>https://www.example.com:8080/*</li>
                        <li>http*://example.com/path</li>
                    </ul>
                </div>

                <div *ngIf="form.get('restriction')?.value == 'IP' " class="col-md-12 mb-3 p-3">
                    <h4 class="mb-2">{{ 'MESSAGES.RESTRICTION_IP_TITLE' | translate }}</h4>
                    <p [innerHTML]="'MESSAGES.RESTRICTION_IP_DESC' | translate"></p>
                    <ul>
                        <li>192.168.0.1、172.16.0.0/12</li>
                        <li>2001:db8::1</li>
                        <li>2001:db8::/64</li>
                    </ul>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button [disabled]="isButtonDisabled" (click)="onNoClick()">{{ 'BUTTON.CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary" [disabled]="isButtonDisabled" (click)="onClickRegist()">{{ 'BUTTON.CREATE' |
        translate }} </button>
</mat-dialog-actions>